// components/markdown/AssistantLink.tsx
"use client";

import React from 'react';
import Link from 'next/link';
import { AssistantLinkPreview } from '@/components/AssistantLinkPreview';

interface AssistantLinkProps {
  href?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export function AssistantLink({ href, children, ...props }: AssistantLinkProps) {
  // Check if this is an assistant link
  const isAssistantLink = href && /^\/assistant\/([a-zA-Z0-9_-]+)/.test(href);

  if (isAssistantLink) {
    // Extract assistant ID from the URL (remove any query params)
    const assistantId = href.replace('/assistant/', '').replace(/\?.*$/, '');

    // Return a preview component instead of a regular link
    return (
      <div className="my-2">
        <AssistantLinkPreview assistantId={assistantId} />
      </div>
    );
  }
  
  // For non-assistant links, render as normal link
  if (href?.startsWith('/')) {
    // Internal link
    return (
      <Link href={href} {...props} className="text-blue-600 hover:text-blue-800 underline">
        {children}
      </Link>
    );
  }
  
  // External link
  return (
    <a href={href} {...props} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
      {children}
    </a>
  );
}